import { Palette } from '../index';
import { palette } from "./palette";

export type ButtonType = {
    button: {
        background: Palette | string,
        position: string,
        padding: string,
        maxWidth: string,
        minWidth: string,
        width: string,
        height: string,
        border: string,
        color: Palette | string,
        borderRadius: string,
        cursor: string,
    }
    buttonHover?: {
        background?: string,
        color?: string,
    },
    buttonActive?: {
        background?: Palette | string
        color?: Palette | string,
        boxShadow?: string,
    },
    buttonDisabled: {
        cursor: string,
        background: Palette | string
        color: Palette | string,
    }
}

export const ButtonStyles: ButtonType = {
    button: {
        background: palette.dark_grey,
        position: 'relative',
        padding: '12px 16px',
        maxWidth: '400px',
        minWidth: '120px',
        width: '100%',
        height: '56px',
        border: 'none',
        color: palette.white,
        borderRadius: '8px',
        cursor: 'pointer',
    },
    buttonDisabled: {
        cursor: 'not-allowed',
        background: palette.disabled_grey,
        color: palette.dark_grey,
    },
    buttonHover: {
        background: palette.primary_dark,
        color: palette.white,
    }
};
